import { Component, OnInit } from '@angular/core';
import { JeevesProductGridViewComponent } from 'gung-standard-jeeves';
import { AuthService, GungAnonymousConfigService, GungFlowService, LocationConfigService, NavbarConfigService, PriceService, Product } from 'gung-standard';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tylo-product-grid-view',
  templateUrl: './tylo-product-grid-view.component.html',
  styleUrls: ['./tylo-product-grid-view.component.css']
})
export class TyloProductGridViewComponent extends JeevesProductGridViewComponent implements OnInit {
  isOnlyDisplay = false;
  currentLang = this.translateService.currentLang || 'se';

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected router: Router,
    protected locationConfigService: LocationConfigService,
    protected navbarConfigService: NavbarConfigService,
    protected translateService: TranslateService,
    protected gungAnonymousConfigService: GungAnonymousConfigService
  ) {
    super(priceService, gungFlowService, authService, gungAnonymousConfigService, router, locationConfigService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.navbarConfigService
      .showCart()
      .pipe(first())
      .subscribe(showCart => (this.isOnlyDisplay = !showCart));
  }

}
